<div>
  <p> {{'confirmDialogText' | translate}}</p>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="basic" id="stop" (click)="closeDialog()">{{'stop' | translate}}</button>
    <button mat-raised-button cdkFocusInitial id="ok" (click)="confirmDialog()" class="custom-button m-l-10">{{'ok' | translate}}</button>
  </div>
</div>